import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  useMediaQuery,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';


import CloudIcon from "@mui/icons-material/Cloud";
import InsertChart from "@mui/icons-material/AddCircle";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import InventoryIcon from "@mui/icons-material/Inventory";
import AddBoxIcon from "@mui/icons-material/AddBox";

import WorkIcon from "@mui/icons-material/Work";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Sidebar = () => {
  const isMobile = useMediaQuery("(max-width:2300px)"); // Responsividade
  const [isOpen, setIsOpen] = useState(!isMobile); // Aberto por padrão no desktop
  const navigate = useNavigate();

  const toggleDrawer = (open) => () => {
    setIsOpen(open);
  };

  const menuItems = [
    { text: "Pedidos Pendentes", icon: <HourglassEmptyIcon />, link: "/dashboard" },
    { text: "Pedidos", icon: <ShoppingCartIcon />, link: "/total_pedidos" },
    { text: "Serviços", icon: <CloudIcon />, link: "/provedores" },
    { text: "Adicionar serviço", icon: <GroupAddIcon />, link: "/new_provedores" },
    { text: "Total Reposição", icon: <InventoryIcon />, link: "/total_reposicao" },
    { text: "Total Inseridos", icon: <AddBoxIcon />, link: "/total_inseridos" },

    { text: "Sair", icon: <LogoutIcon />, link: "/adminseja" },

  ];

  return (
    <div style={{ display: "flex" }}>
        <ToastContainer />
      {/* Botão de menu para mobile */}
      {isMobile && (
        <IconButton
          edge="start"
          onClick={toggleDrawer(true)}
          style={{
            height:50,
            width:50,
            margin: "10px",
            backgroundColor: "#6200EE",
            color: "#fff",
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Menu lateral */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        anchor="left"
        open={isOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          style: {
            width: "280px",
            backgroundColor: "#1E1E2F",
            color: "#fff",
            borderRight: "1px solid #2C2C3A",
          },
        }}
      >
        {/* Cabeçalho do Menu */}
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            backgroundColor: "#2A2A3D",
            borderBottom: "1px solid #39394D",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold",color:'white' }}>
            Painel Reposição
          </h3>
        </div>
        <Divider style={{ backgroundColor: "#39394D" }} />
        {/* Itens do Menu */}
        <List>
          {menuItems.map((item, index) => (
            <ListItem
              button
              key={index}
              style={{
                padding: "15px 20px",
                margin: "5px 10px",
                borderRadius: "8px",
                transition: "background-color 0.3s",
                color: "#fff",
                cursor: "pointer",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#39394D")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
              onClick={() => navigate(item.link)} // Use navigate aqui

            >
              <ListItemIcon style={{ color: "#BB86FC" }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </div>
  );
};

export default Sidebar;
